/*=========================================================================================
  File Name: store.js
  Description: Vuex store
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)

// import moduleTodo from './todo/moduleTodo.js'
// import moduleCalendar from './calendar/moduleCalendar.js'
// import moduleChat from './chat/moduleChat.js'
// import moduleEmail from './email/moduleEmail.js'
import moduleAuth from './auth/moduleAuth.js'
import moduleECommerce from './eCommerce/moduleECommerce.js'
import moduleEvolugy from './evolugy/moduleEvolugy.js'
import modulePermissions from './permissions/modulePermissions.js'
import moduleEvent from './event/moduleEvent.js'
import moduleClinic from './clinic/moduleClinic.js'
import moduleUserManagement from './user-management/moduleUserManagement.js'
import moduleExam from './exam/moduleExam.js'
import moduleForm from './form/moduleForm.js'
import moduleMedication from './medication/moduleMedication.js'
import modulePrescription from './prescription/modulePrescription.js'


export default new Vuex.Store({
  getters,
  mutations,
  state,
  actions,
  modules: {
    // todo: moduleTodo,
    // calendar: moduleCalendar,
    // chat: moduleChat,
    // email: moduleEmail,
    auth: moduleAuth,
    eCommerce: moduleECommerce,
    evolugy: moduleEvolugy,
    permissions: modulePermissions,
    event: moduleEvent,
    userManagement: moduleUserManagement,
    clinic: moduleClinic,
    exam: moduleExam,
    form: moduleForm,
    medication: moduleMedication,
    prescription: modulePrescription
    // GET, SET, UPDATE, LIST, VALIDATE
  },
  strict: process.env.NODE_ENV !== 'production'
})
